<h3 *ngIf="header">{{ header }}</h3>
<h4 *ngIf="label">{{ label }}{{ isRequired ? " *" : "" }}</h4>
<div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
    <div fxFlex="100" fxLayoutAlign="start center" fxFlex.xs="100" fxFlexFill>
        <span
            class="radio-checkbox-group"
            fxFlex="100"
            *ngIf="formGroup && control && formControlName"
        >
            <mat-radio-group
                *ngIf="control"
                [formControlName]="formControlName"
                color="primary"
                (change)="updateRadioGroup($event)"
            >
                <ul>
                    <li *ngFor="let selection of selections">
                        <mat-radio-button
                            [checked]="control.value === selection.selectionId"
                            [value]="selection.selectionId.toString()"
                        >
                            <span class="wrap-mat-radio-checkbox-label">
                                {{ selection.label }}
                            </span>
                        </mat-radio-button>
                    </li>
                </ul>
            </mat-radio-group>
            <mat-error
                *ngIf="
                    ((control && control.touched) || formSubmitted) &&
                    isRequired
                "
                >{{ requiredMessage }}
            </mat-error>
        </span>
    </div>
</div>
